export default "__VITE_ASSET__4e3ba363__"